// src/contexts/UserContext.jsx (修正版)
import React, { createContext, useState, useContext, useMemo, useEffect } from 'react';
import { useAuth } from '../AuthContext'; // AuthContextから認証情報を取得するように変更

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  // AuthContextから取得した、現在ログインしているユーザーのプロファイルを使うように変更
  const { profile: authProfile, loading } = useAuth();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if(authProfile) {
      setProfile(authProfile);
    }
  }, [authProfile]);

  const updateUserAbilities = (newAbilities) => {
    if (!profile) return;

    const updatedAbilities = profile.nobishiroAbilities.map(oldAbility => {
        const newAbility = newAbilities.find(na => na.name === oldAbility.name);
        return newAbility ? { ...oldAbility, score: parseFloat(newAbility.score) } : oldAbility;
    });

    const updatedProfile = {
      ...profile,
      nobishiroAbilities: updatedAbilities
    };
    setProfile(updatedProfile);
  };

  const value = useMemo(() => ({
    profile,
    loading, // ローディング状態も渡す
    updateUserAbilities
  }), [profile, loading]);

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};